export const SIZES = {
  small: '12px',
  medium: '32px',
  large: '56px',
}
